/**
 * 配列内で重複している要素を取得する。
 *
 * @param items - 対象の配列
 * @param getKey - 比較に使用するキーを返す関数（省略時は要素そのものを比較）
 * @returns 重複した要素（最初に出現した値を返す）
 */
export const getDuplicates = <T>(items: T[], getKey: (item: T) => unknown = (item) => item): T[] => {
  const seen = new Map<unknown, T>();
  const duplicates = new Map<unknown, T>();

  items.forEach((item) => {
    const key = getKey(item);

    if (seen.has(key)) {
      duplicates.set(key, seen.get(key) as T);
    } else {
      seen.set(key, item);
    }
  });

  return Array.from(duplicates.values());
};

export default {
  getDuplicates,
};
